<template>
  <v-stepper v-model="e1">
    <template>
      <modalError ref="modalError"/>
      <modalAlert ref="modalAlert" />
      <v-stepper-header v-show="steps > 1">
        <template v-for="n in steps">
          <v-stepper-step
            :key="`${n}-step`"
            :complete="e1 > n"
            :step="n"
          >
            <span v-if="votesPerVoter.length > 1" />
          </v-stepper-step>

          <v-divider
            v-if="n !== steps"
            :key="n"
          />
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-progress-linear
          v-show="progressBar"
          slot="progress"
          color="blue"
          indeterminate
        />
        <v-stepper-content
          :step="confirmation"
          class="rmv-padding"
        >
          <v-row no-gutters>
            <v-col
              cols="12"
              sm="12"
            >
              <span v-if="showVoteInfo">
                <br />
                <v-alert
                  type="success"
                >
                  Seu voto foi realizado com sucesso.
                </v-alert>
                <p>Eleição: {{$store.state.vote.electionName}}</p>
                <p>Título: {{$store.state.vote.identifier}}</p>
                <p>Nome: {{$store.state.vote.name}}</p>
                <p>Data: {{$store.state.vote.votedOn}}</p>
              </span>
            </v-col>
          </v-row>
          <br />
          <br />
          <!-- <div
            class="col-1"
            v-if="bHidden"
          >
            <v-btn
              @click="printPage"
              tile
              block
              type="btn"
              class="blue-box white-text"
            >
              Imprimir
            </v-btn>
          </div> -->
        </v-stepper-content>

        <v-stepper-content
          v-for="n in steps"
          :key="`${n}-content`"
          :step="n"
          class="rmv-padding"
        >
          <v-container fluid>
            <v-row
              align="center"
              justify="center"
            >
              <v-row
                align="center"
                justify="center"
              >
                <span>{{candidateRolesCurrent ? candidateRolesCurrent.name : ''}}</span>
              </v-row>
              <div class="col-12">
                <v-row
                  no-gutters
                  align="center"
                  justify="center"
                >
                  <v-col
                    sm="6"
                    class="div-minima"
                  >
                    <v-row
                      align="center"
                      justify="center"
                    >
                      <v-col
                        cols="12"
                        class="rmv-padding"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            class="rmv-padding"
                          />

                        </v-row>
                        <v-skeleton-loader
                          :loading="loading"
                          type="avatar, image, list-item-two-line"
                          height="100%"
                        >
                          <span
                            class="custom-selector caption"
                            v-show="showImage"
                          >
                            <v-row
                              align="center"
                              justify="center"
                            >
                              <v-avatar
                                width="50%"
                                height="30%"
                                class="mb-2"
                                tile
                              >
                                <img
                                  :src="picture"
                                  aspect-ratio="1.0"
                                />
                              </v-avatar>
                            </v-row>
                            <v-row
                              align="center"
                              justify="center"
                            >
                              <v-card-title class="text-md-center rmv-padding">{{number}}</v-card-title>
                            </v-row>
                            <v-row
                              align="center"
                              justify="center"
                            >
                              <v-card-title class="rmv-padding">{{nickname}}</v-card-title>
                            </v-row>
                          </span>
                        </v-skeleton-loader>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="6"
                    class="div-minima"
                  >
                    <v-form
                      ref="form"
                      lazy-validation
                    >
                      <v-row
                        align="center"
                        justify="center"
                        class="mb-2"
                      >
                        <span>Digite o número do seu candidato</span>
                      </v-row>
                      <v-row
                        align="center"
                        justify="center"
                      >
                        <div
                          v-for="item in NumberInformation"
                          :key="item.index"
                          class="div-number-information"
                        >
                          <span>{{item}}</span>
                        </div>
                      </v-row>
                      <v-row
                        align="center"
                        justify="center"
                      >
                        <v-col
                          cols="8"
                          class="urna_teclado"
                        >
                          <div class="teclas">
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('1')"
                            >1</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('2')"
                            >2</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('3')"
                            >3</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('4')"
                            >4</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('5')"
                            >5</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('6')"
                            >6</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('7')"
                            >7</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('8')"
                            >8</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('9')"
                            >9</v-btn>
                            <v-btn
                              x-large
                              outlined
                              :disabled="disableKey"
                              @click="urna_fill('0')"
                            >0</v-btn>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row
                        align="center"
                        justify="center"
                      >
                        <v-row
                          cols="12"
                          class="urna_teclado"
                        >
                          <div class="teclas_acao col-12">
                            <v-btn
                              @click="urna_fill('BRANCO')"
                              class="mr-1"
                            >Branco</v-btn>
                            <v-btn
                              color="error"
                              @click="urna_fill('Corrige')"
                              class="mr-1"
                            >Corrige</v-btn>
                            <v-btn
                              ref="btnConfirm"
                              color="green"
                              @click="nextStep(n)"
                              :disabled="!isAllowedToContinue"
                            >Confirma</v-btn>
                          </div>
                        </v-row>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </div>
            </v-row>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </template>
  </v-stepper>
</template>

<script>
import { mapActions } from 'vuex';
import { setUrna } from '@/global';
import modalError from '@/components/ModalError';
import modalAlert from '@/components/ModalAlert';

var selectedStatus = null;

export default {
  components: {
    modalError,
    modalAlert
  },
  props: {
    source: String
  },
  data: () => ({
    appName: 'Eleições',
    urnaNumber: '',
    validForm: false,
    requiredRules: [v => !!v || 'Campo obrigatório'],
    showImage: false,
    number: '',
    name: '',
    nickname: '',
    picture: null,
    votes: [],
    isAllowedToContinue: false,
    statusAlert: '',
    msgAlert: '',
    statusVote: '',
    showVoteInfo: false,
    votesPerVoter: 0,
    // stepper
    e1: '',
    steps: 1,
    altLabels: false,
    elections: [],
    confirmation: 0,
    NumberInformation: [],
    MaxNumberInformation: 4,
    imgPadrao: require('@/assets/img/Empty.png'),
    loading: false,
    dialog: false,
    stepCurrent: null,
    disableKey: false,
    progressBar: false,
    bHidden: true,
    clientIp: '',
    candidateRolesList: null,
    candidateRolesCurrent: null,
    RolesList: null,
    stepsCompletes: null,
    contadorVotos: 0,
    valueEvent: '',
    physicalKeyboard: false,
    TimerEnd: {
      bFlagActivateTimer: false,
      value: null
    },
    TimerUrn: {
      bFlagActivateTimer: false,
      value: null
    },
    timoutUrn: null
  }),
  computed: {},
  watch: {
    urnaNumber(val) {
      if (val.length === this.MaxNumberInformation) {
        this.showImage = true;
        if (this.votes.indexOf(val) !== -1) {
          this.votoNulo();
          alert('Já existe um voto para o número informado.');
        } else {
          this.getCandidate(val);
        }
      }
    },
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    statusVote(val) {
      this.getVote();
    },
    physicalKeyboard(val) {
      if (val) {
        window.addEventListener('keypress', this.onKeyPress);
      } else {
        window.removeEventListener('keypress', this.onKeyPress);
      }
    },
    showVoteInfo(val) {
      if (val) {
        if (this.TimerEnd.bFlagActivateTimer) {
          setTimeout(() => {
            this.$store.state.logout();
          }, this.TimerEnd.value);
        }
      }
    },
    'TimerUrn.bFlagActivateTimer': function(value) {
      this.createDestroyTimeOut(value);
    }
  },
  destroyed() {
    window.removeEventListener('keypress', this.onKeyPress);
    this.createDestroyTimeOut(false);
  },
  mounted() {
    if (!this.$store.state.login.accessValid) {
      this.$router.push({ name: 'Login' });
    }
    this.getElection();
  },
  methods: {
    ...mapActions('vote', { saveVote: 'save', get: 'get' }),
    ...mapActions('candidate', { getCandidateByElctionId: 'get' }),
    ...mapActions('election', { getByElctionId: 'get' }),
    ...mapActions('candidate', { clearCandidate: 'clearCandidate' }),

    onKeyPress(e) {
      this.sendNumber(e.key);
    },
    urna_setup() {
      this.e1 = 1;
      var list = [];
      if (this.MaxNumberInformation > 0) {
        for (let i = 0; i < this.MaxNumberInformation; i++) {
          list.push('');
        }
      }
      this.NumberInformation = list;

      fetch('https://api.ipify.org?format=json').then(response => response.json()).then(response => {
        this.clientIp = response.ip;
      });
    },
    urna_fill(valor) {
      setUrna(valor, this);
      this.processUrnaNumber();
      selectedStatus = null;
      if (valor === 'Corrige') {
        selectedStatus = 'corrige';
        this.clearCandidate();
      }
      if (valor === 'BRANCO') {
        selectedStatus = 'branco';
        this.clearCandidate();
        this.votoBranco();
      }
    },
    onInput(val) {
      this.steps = parseInt(val);
    },
    async nextStep(n) {
      if (!this.validationExistVote()) {
        this.stepCurrent = null;
        this.contadorVotos++;
        if (n === this.steps) {
          // Last step
          this.progressBar = true;
          this.insertVoterArray(this.urnaNumber);
          const dataPost = {
            identifier: this.$store.state.login.identifier,
            region: this.$store.state.voter.region_id,
            votes: [],
            has_voted: false,
            electionId: this.$store.state.login.election,
            clientIp: this.clientIp
          };

          for (var i = 0; i < this.votes.length; i++) {
            dataPost.votes.push(this.votes[i]);
          }
          this.votes = [];
          try {
            await this.saveVote({
              vote: dataPost
            }).then(() => {
              if (this.$store.state.vote.status === 'ok') {
                this.statusVote = 'ok';
                this.e1 = n + 1;
              } else if (this.$store.state.vote.msgError === 'Vote not committed') {
                this.saveVote({
                  vote: dataPost
                }).then(() => {
                  if (this.$store.state.vote.status === 'ok') {
                    this.e1 = n + 1;
                    this.statusVote = 'ok';
                  } else {
                    this.$refs.modalError.Load(true, this.$store.state.logout);
                  }
                });
              } else {
                this.statusAlert = 'error';
                this.msgAlert = 'Voto não pode ser realizado !';
                this.$refs.modalError.Load(true, this.$store.state.logout);
              }
            });
          } catch (error) {
            this.$refs.modalError.Load(true, this.$store.state.logout);
          } finally {
            this.loading = false;
          }
        } else {
          this.e1 = n + 1;
          this.insertVoterArray(this.urnaNumber);
          this.urnaNumber = '';
          this.picture = '';
          this.isAllowedToContinue = null;
          this.showImage = false;
          this.processUrnaNumber();
          this.disableKey = false;
          if (this.RolesList && this.RolesList.length > 0) {
            if (this.contadorVotos === this.votesPerVoter) {
              this.selectCurrentRole();
              this.contadorVotos = 0;
            }
          }
        }
      } else {
        this.$refs.modalAlert.Load(
          true,
          'Eleição',
          'Já existe um voto para este candidato.',
          'error'
        );
      }
    },
    insertVoterArray(number) {
      const voteData = {
        roleID: null,
        candidateNumber: null
      };

      if (this.candidateRolesCurrent) {
        voteData.roleID = this.candidateRolesCurrent.id;
      }

      if (
        this.$store.state.candidate.number &&
        this.$store.state.candidate.number.toString() === this.urnaNumber
      ) {
        voteData.candidateNumber = this.urnaNumber;
        this.votes.push(voteData);
      } else if (this.urnaNumber === 'BRANCO') {
        voteData.candidateNumber = '-1';
        this.votes.push(voteData);
      } else {
        voteData.candidateNumber = '-2';
        this.votes.push(voteData);
      }
    },
    validationExistVote() {
      let bFlag = false;
      if (this.votes.length > 0) {
        const arrayResult = this.votes.filter(x => x.candidateNumber === this.urnaNumber);
        if (arrayResult && arrayResult.length > 0) {
          bFlag = true;
        }
      }
      return bFlag;
    },
    async getCandidate(val) {
      this.loading = true;
      var election = {};
      if (this.candidateRolesCurrent && this.candidateRolesCurrent.id) {
        election.electionId = this.$store.state.login.election;
        election.idCandidate = val;
        election.idCandidateRole = this.candidateRolesCurrent.id;
      } else {
        election.electionId = this.$store.state.login.election;
        election.idCandidate = val;
      }
      election.voting = this.$store.state.election.voting;
      try {
        await this.getCandidateByElctionId({
          election: election
        }).then(() => {
          if (this.$store.state.candidate.number > 0) {
            this.number = this.$store.state.candidate.number;
            this.name = this.$store.state.candidate.name;
            this.nickname = this.$store.state.candidate.nickname;
            if (this.$store.state.candidate.picture != null) {
              this.picture = this.$store.state.candidate.picture;
            } else {
              this.picture = this.imgPadrao;
            }
            this.showImage = true;
            setTimeout(() => {
              if (selectedStatus === 'corrige') {
                this.showImage = false;
                this.nickname = null;
                this.number = null;

                selectedStatus = null;
                this.isAllowedToContinue = false;
              } else {
                this.isAllowedToContinue = true;
              }
            }, 1000);
          } else {
            this.votoNulo();
          }
          this.loading = false;
        });
      } catch (error) {
        this.votoNulo();
      } finally {
        this.loading = false;
      }
    },

    async getVote() {
      await this.get({
        idElection: this.$store.state.login.election
      });
      if (this.$store.state.vote.has_voted) {
        this.statusAlert = 'success';
        this.msgAlert = 'Voto realizado com sucesso !';
        this.createDestroyTimeOut(false);
        this.showVoteInfo = true;
        this.progressBar = false;
        this.$store.commit('setShowAlertManyVotes', false);
      }
    },
    async getElection() {
      await this.getByElctionId({
        idElection: this.$store.state.login.election
      });
      this.votesPerVoter = this.$store.state.election.votesPerVoter;
      this.candidateRolesList = this.$store.state.election.candidateRolesArray;
      this.RolesList = this.candidateRolesList;
      if (this.candidateRolesList && this.candidateRolesList.length > 0) {
        this.steps = this.candidateRolesList.length * this.votesPerVoter;
        this.confirmation = this.steps + 1;
      } else if (this.votesPerVoter > 0) {
        this.steps = this.votesPerVoter;
        this.confirmation = this.votesPerVoter + 1;
      }
      this.physicalKeyboard = this.$store.state.election.physicalKeyboard;
      this.TimerEnd.bFlagActivateTimer = this.$store.state.election.receiptTime;
      this.TimerEnd.value = this.$store.state.election.receiptTimeValue;
      this.TimerUrn.bFlagActivateTimer = this.$store.state.election.votingTime;
      this.TimerUrn.value = this.$store.state.election.votingTimeValue;
      this.urna_setup();
      this.selectCurrentRole();
    },
    processUrnaNumber() {
      this.NumberInformation = [];
      var ArrayUrnaNumber = this.urnaNumber
        .toString(10)
        .replace(/\D/g, '')
        .split('')
        .map(Number);

      for (let index = 0; index < this.MaxNumberInformation; index++) {
        if (index < ArrayUrnaNumber.length) {
          this.NumberInformation.push(ArrayUrnaNumber[index]);
        } else {
          this.NumberInformation.push('');
        }
      }
    },
    votoNulo() {
      this.picture = this.imgPadrao;
      this.nickname = 'Voto Nulo';
      this.number = '';
      this.showImage = true;
      setTimeout(() => {
        if (selectedStatus === 'corrige') {
          this.showImage = false;
          this.nickname = null;
          this.number = null;

          selectedStatus = null;
          this.isAllowedToContinue = false;
        } else {
          this.isAllowedToContinue = true;
        }
      }, 1000);
    },
    votoBranco() {
      this.picture = this.imgPadrao;
      this.nickname = 'Voto em Branco';
      this.number = '';
      this.showImage = true;
      this.disableKey = true;
      setTimeout(() => {
        if (selectedStatus === 'corrige') {
          this.showImage = false;
          this.nickname = null;
          this.number = null;

          selectedStatus = null;
          this.isAllowedToContinue = false;
        } else if (selectedStatus === 'branco') {
          this.picture = this.imgPadrao;
          this.nickname = 'Voto em Branco';
          this.number = '';

          selectedStatus = null;
          this.isAllowedToContinue = true;
        } else {
          this.isAllowedToContinue = true;
        }
      }, 1000);
    },
    confirmNullVote() {
      this.dialog = false;
      this.nextStep(this.stepCurrent);
    },
    printPage() {
      this.bHidden = false;
      window.print();
      this.bHidden = true;
    },
    selectCurrentRole() {
      if (this.RolesList && this.RolesList.length > 0) {
        this.candidateRolesCurrent = this.RolesList[0];
        this.RolesList = this.RolesList.filter(item => item !== this.candidateRolesCurrent);
      }
    },
    sendNumber(valueNumber) {
      const arrayNumber = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
      const Confirm = 'Enter';
      const Corrige = '-';
      const Branco = '*';
      const valueString = valueNumber.toString();
      if (arrayNumber.includes(valueString)) {
        this.urna_fill(valueString);
      } else {
        if (valueString === Corrige) {
          this.urna_fill('Corrige');
        } else if (valueString === Branco) {
          this.urna_fill('BRANCO');
        } else if (valueString === Confirm) {
          if (this.isAllowedToContinue) {
            this.$refs.btnConfirm[0].$el.click();
          }
        }
      }
    },
    createDestroyTimeOut(bCreateDestroy) {
      if (bCreateDestroy) {
        var time = this.TimerUrn.value;
        this.timoutUrn = setTimeout(() => {
          this.$store.state.logout();
        }, time);
      } else {
        if (this.timoutUrn) {
          clearInterval(this.timoutUrn);
        }
      }
    }
  }
};
</script>

<style>
.v-application--wrap {
  min-height: 100vh !important;
}
</style>
